import { motion, useScroll, useTransform } from 'framer-motion'

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll()

  const bg = useTransform(scrollYProgress, [0, 0.5, 1], ['#c8a96e', '#a86e9f', '#6e8fc8'])

  return (
    <motion.div
      className="scroll-progress"
      style={{ scaleX: scrollYProgress, transformOrigin: '0%', background: bg }}
      aria-hidden="true"
    />
  )
}
